import { FC } from "react";
import { Text } from "@fluentui/react";
import UploadDocumentIcon from "../../assets/Icons/svg/uploadDocumentIcon";
import "./DragAndDrop.css";

export const DragOverlay: FC = () => (
  <div className="dragOverlay">
    <div className="dragOverlayBox" />
    <div className="dragOverlayContent">
      <UploadDocumentIcon width="29px" height="29px" />
      <Text className="dragOverlayText">Upload files to Dexterity</Text>
    </div>
  </div>
);
